import { render } from "./Parallax.vue?vue&type=template&id=554e5426&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"

import "./Parallax.vue?vue&type=style&index=0&id=554e5426&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554e5426"]])

export default __exports__